import React, { useState } from 'react'
import { Button } from '../../../../common/lib'
import { DialogBox } from '../../../../common/components'

const ArticleFeedback = () => {
  const [showModal, setShowModal] = useState(false)
  const handleFeedback = ({ target: { value } = {} }) => {
    setShowModal(!showModal)
    window.dataLayer.push({
      event: 'feedback',
      value,
    })
  }
  const handleClose = () => {
    setShowModal(!showModal)
  }
  return (
    <>
      <DialogBox
        title="Have your say"
        message="Thanks for the feedback"
        onClose={handleClose}
        open={showModal}
      />
      <div className="article-feedback d-block d-md-block d-sm-none d-xs-none">
        <h2 className="text-center">Was this article helpful?</h2>
        <br />
        <div className="btnWrapper">
          <>
            <Button
              className="btn-round btn-round-left"
              color="info"
              value={1}
              outline
              onClick={handleFeedback}
            >
              Yes
            </Button>
            <Button
              className="btn-round btn-round-right"
              color="danger"
              outline
              value={-1}
              onClick={handleFeedback}
            >
              No
            </Button>
          </>
        </div>
      </div>
    </>
  )
}

export default ArticleFeedback
